module.exports = __webpack_public_path__ + "img/special-content.60312a78.jpg";